import type { ModalBaseProps } from 'react-native';

/**
 * Fallback for non-iOS platforms.
 */
export function getIosModalPresentationConfig(
  overrides: PresentationConfig = {},
): PresentationConfig {
  return {
    animationType: 'fade',
    transparent: false,
    ...overrides,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

/**
 * Leaves out `onRequestClose`, so spreading the config doesn't clash with garnish `Modal`'s handler.
 */
type PresentationConfig = Omit<ModalBaseProps, 'onRequestClose'>;
